const BD_Helper = {
	removeItemOnce: (arr, value) => {
		var index = arr.indexOf(value);
		if (index > -1) {
			arr.splice(index, 1);
		}
		return arr;
	},
	escapeHtml (string) {
		var entityMap = {
			'&': '&amp;',
			'<': '&lt;',
			'>': '&gt;',
			'"': '&quot;',
			"'": '&#39;',
			'/': '&#x2F;',
			'`': '&#x60;',
			'=': '&#x3D;'
		  };

		return String(string).replace(/[&<>"'`=\/]/g, function (s) {
		  return entityMap[s];
		});
	},

	isUndefined(value){
		return typeof value == 'undefined';
	},
	/**
	 * @example
	 * const object = {
	 *  1: { name: "Foo" },
	 *  2: { name: "Bar" }
	 * };
	 * const result = indexedObjectToArray(object);
	 * console.log(result);
	 * // output: [{ name: "Foo" }, { name: "Bar" }]
	 * @param {Object} obj
	 */
	indexedObjectToArray(obj) {
		if (!obj) return [];
		if (typeof obj !== "object") return [];
		return Object.keys(obj).map((key) => obj[key]);
	},

	suffixURL() {
		const getLang = () => {
			const urlSearchParams = new URLSearchParams(window.location.search);
			const params = Object.fromEntries(urlSearchParams.entries());
			return params.lang;
		}

		const lang = getLang()
		return lang ? '?lang=' + lang : ''
	}

};
